'use client'
import { useComponentTranslation } from '@core/i18n'
import { Box, Text } from '@core/ui-elements'
import { TFunction, Trans } from 'next-i18next'
import { useCallback } from 'react'

import { useBottomSheet } from '../../../bottom-sheet'

export const useDeliveryAlreadyPickingBottomSheet = () => {
  const t = useComponentTranslation('SetIndentification')
  const { openError, onClose } = useBottomSheet()

  const openDeliveryAlreadyPicking = useCallback(() => {
    openError({
      header: {
        label: t('Request already in separation'),
      },
      canClose: true,
      children: (
        <Box>
          <Text as="p" fontWeight="600">
            {t(
              'Heck, another professional in the store has already started to separate this request'
            )}
          </Text>
          <Text as="p">
            <Trans
              i18nKey={
                'If there are pending orders, you can start separating another order'
              }
              t={t as TFunction}
            />
          </Text>
        </Box>
      ),
      footerButtons: [
        {
          children: t('Back to orders'),
          onClick: onClose,
          width: '100%',
          size: 'md',
        },
      ],
    })
  }, [onClose, openError, t])

  return {
    openDeliveryAlreadyPicking,
  }
}
